import React from 'react'
import { Route } from 'react-router-dom'

import withAuthenticated from './AuthenticationProvider'

import renderWhen from './renderWhen'

interface IProtectedRouteProps {
  authenticated: boolean
  component: React.ComponentClass | React.StatelessComponent
  path: string
}

export class ProtectedRoute extends React.Component<IProtectedRouteProps> {
  render() {
    const { component, authenticated, ...props } = this.props

    return <Route {...props} render={renderWhen(authenticated, component)} />
  }
}

export default withAuthenticated(ProtectedRoute)
